import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, ModelDataService, UserService } from 'yt-ng-framework';
import { Vozilo } from './vozilo';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-vozilo',
  templateUrl: './vozilo.component.html'
})
export class VoziloComponent extends BaseModalContainer<Vozilo> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Vozilo>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService,
    protected modelDataService: ModelDataService
  ) { 
    super(modalContainerService
      , activatedRoute
      , modalService
      , userService
      , modelDataService
    )
  }

  ngOnInit() {
  }

}
